import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  input[type='radio'] {
    cursor: pointer;
    accent-color: var(--primary_color);
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 0.9rem;
    height: 0.9rem;
    border: 0.1rem solid #ccc;
    border-radius: 50%;
    position: relative;
    outline: none;
  }

  input[type='radio']:checked {
    border: 0.1rem solid var(--primary_color);
  }

  input[type='radio']:not(:checked) {
    border: 0.1rem solid var(--primary_color);
  }

  input[type='radio']:checked::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    background-color: var(--primary_color);
    transform: translate(-50%, -50%);
  }

  label {
    font-size: 1rem !important;
    font-weight: 500;
    color: var(--primary_color);
  }
`;
